import request from '../../bin/httpRequest';
import { getProductItem, queryFunction } from '~/store/Query/api';

/**
 * @param {string} product - is required.
 */
const productDetail = (product) => {
  const partNumber = product.split('/');
  const options = {
    method: 'GET',
    url: `${process.env.NEXT_PUBLIC_MONGO_API}${process.env.NEXT_PUBLIC_MERCHANT}/product/${partNumber[partNumber.length - 1]}?lang=es_mx&currency=mxn`,
  };

  return request.genericHandler(options).then((res) => {
    let callback = { action: 'product', success: false };
    if (!res.error) {
      callback = { ...callback, data: res.data, success: true };
    } else {
      callback = { ...callback, error: res.error };
    }
    return callback;
  });
};

const productItem = partNumber => queryFunction('productItem', () => getProductItem(partNumber));

const productCaracteristicasPrincipales = (partNumber) => {
  const options = {
    method: 'GET',
    url: `${process.env.NEXT_PUBLIC_MONGO_API}${process.env.NEXT_PUBLIC_MERCHANT}/products/${partNumber}/datamain`,
  };

  return request.genericHandler(options).then((res) => {
    let callback = { action: 'productItem', success: false };
    if (!res.error) {
      callback = { ...callback, data: res.data, success: true };
    } else {
      callback = { ...callback, error: res.error };
    }
    return callback;
  });
};

export { productItem, productCaracteristicasPrincipales };
export default productDetail;
